import {Component, OnInit, ViewChild} from '@angular/core';
import {ModalDirective} from "ngx-bootstrap";
import {TenantService} from '../../services/tenant.service';

@Component({
  selector: 'app-tooltip',
  templateUrl: 'tooltip.component.html',
  styleUrls: ['tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
  @ViewChild('tooltipModal') public tooltipModal: ModalDirective;

  isWeb:Boolean;
  isExp:Boolean;
  isBuy:Boolean;
  subject = '';
  tenant;
  constructor(private tenantService: TenantService) {  }

  ngOnInit() {

    const self = this;
    self.tenantService.getTenantWithPromise().then((response) => {
      self.tenant = response;
    });
  }
  public showtooltipModal(): void {
    this.tooltipModal.config.backdrop = false;
    this.tooltipModal.show();
  }

  public hidetooltipModal(): void {
    this.tooltipModal.hide();
  }

  isWebinar() {
    this.isWeb = true;
    this.isExp = false;
    this.isBuy = false;
  }
  isExpert() {
    this.isExp = true;
    this.isWeb = false;
    this.isBuy = false;
  }
  isBuyer() {
    this.isBuy = true;
    this.isWeb = false;
    this.isExp = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/tooltip/tooltip.component.ts